import styled, { css } from 'styled-components';

const TextContainer = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  ${({ theme, withReadMore, withLineHeight, withMaxLines, withMaxHeight }) =>
    css`
      margin-top: ${theme.spacing(2)};
      line-height: ${withLineHeight}px;
      color: ${theme.colors.night_blue_2};
      ${theme.fontFamily.secondaryFont.xSmallRegular};
      -webkit-line-clamp: ${withReadMore ? withMaxLines : 'unset'};
      line-clamp: ${withReadMore ? withMaxLines : 'unset'};
      height: ${withReadMore
        ? `calc(${withLineHeight}px * ${withMaxLines})`
        : `${withMaxHeight}px`};
      max-height: ${withMaxHeight}px;
      transition: height 0.5s ease;
    `}
`;

export default TextContainer;
